import { render } from "./VertragWizardFoerdervertragsbestaetigung.pug?vue&type=template&id=b152622a&lang=pug"
import script from "./VertragWizardFoerdervertragsbestaetigung.js?vue&type=script&lang=js"
export * from "./VertragWizardFoerdervertragsbestaetigung.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__